import {some} from 'lodash';

export default {
  educationListState(state) {
    return state.educationList;
  },
  educationErrorListState(state) {
    return state.educationErrorList;
  },
  educationHasErrorsListState(state) {
    return state.educationErrorList.map(item => {
      return some(Object.values(item));
    });
  }
};
